/**
 * Entry point. Mounts the console and nothing else — providers live in App.tsx and the
 * route table in router.tsx.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from '@/App';
import '@/styles.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('index.html is missing <div id="root"> — the bundle has nowhere to mount.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
